import { Reducer } from 'react';

/** Persisted in reducer — only subscription rows (client toasts use Apollo `messages`). */
export interface StoredSubscriptionNotification {
  id: string;
  createdAt: number;
  notificationId: string;
  channelId: string;
  subject: string;
  messageHtml: string;
  url?: string | null;
}

export interface InAppStackState {
  subscriptionItems: StoredSubscriptionNotification[];
}

export enum InAppStackActionType {
  PushSubscription = 'PUSH_SUBSCRIPTION',
  Remove = 'REMOVE',
}

export type InAppStackAction =
  | { type: InAppStackActionType.PushSubscription; payload: StoredSubscriptionNotification }
  | { type: InAppStackActionType.Remove; payload: { id: string } };

const MAX_STORED_SUBSCRIPTION_ITEMS = 20;

export const inAppStackInitialState: InAppStackState = {
  subscriptionItems: [],
};

export const inAppStackReducer: Reducer<InAppStackState, InAppStackAction> = (state, action) => {
  switch (action.type) {
    case InAppStackActionType.PushSubscription: {
      const item = action.payload;
      const withoutDup = state.subscriptionItems.filter(
        (i) => i.notificationId !== item.notificationId
      );
      return {
        subscriptionItems: [item, ...withoutDup].slice(0, MAX_STORED_SUBSCRIPTION_ITEMS),
      };
    }
    case InAppStackActionType.Remove: {
      return {
        subscriptionItems: state.subscriptionItems.filter((i) => i.id !== action.payload.id),
      };
    }
    default:
      return state;
  }
};
